import { fontWeightConfig } from "../common";
import { colors } from "./colors";

export const sidebarConfiguration = {
  sidebarWidth: "215px",
  sidebarMiniWidth: "80px",
  sidebarBorderColor: "rgba(133, 145, 158, 0.2)",
  collapseButtonShadow: "0px 6px 6px #698ebe29",
  textColor: "#000E2A",
  fontSize: "14px",
  hoverColor: colors.textSecondary,
  activeColor: colors.primary,
  singleLink: {
    activeBgColor: "#EDF8FE",
    activeTextColor: colors.primary,
    activeBorderRadius: "32px",
    activeHeight: "34px",
    activeBorderColor: colors.primary,
  },
  linkGroup: {
    borderColor: "rgba(133, 145, 158, 0.1)",
    fontWeight: fontWeightConfig.regular,
  },
  collapseLink: {
    width: "15px",
    height: "15px",
    fontSize: "10px",
    fontWeight: fontWeightConfig.medium,
    textColor: colors.white,
    bgColor: "rgba(61, 77, 105, 0.3)",
    hoverBgColor: "rgba(61, 77, 105, 0.5)",
    activeBgColor: colors.primary,
  },
  imageFilter: {
    hover: `brightness(0) saturate(100%) invert(27%) sepia(11%)
    saturate(1622%) hue-rotate(180deg) brightness(97%) contrast(89%)`,
    active: `brightness(0) saturate(100%) invert(38%) sepia(98%) 
    saturate(2000%) hue-rotate(212deg) brightness(94%) contrast(93%)`,
    seeMoreActive: `brightness(0) saturate(100%) invert(66%) sepia(26%) 
    saturate(6964%) hue-rotate(132deg) brightness(102%) contrast(75%)`,
  },
  profileSection: {
    height: "65px",
    nameFontSize: "14px",
    nameTextColor: colors.textSecondary,
  },
};
